import { render } from "./StudentSubmissions.vue?vue&type=template&id=6041c476"
import script from "./StudentSubmissions.vue?vue&type=script&lang=js"
export * from "./StudentSubmissions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__